module.exports = __webpack_public_path__ + "static/img/aypz.c9a67bc.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aypz.jpeg
// module id = Qm8d
// module chunks = 4